<template>
  <div>
    <video v-if="mediaFile" controls class="w-full" :autoplay="false">
      <source :src="mediaFile" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: 'VideoBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mediaFile: null
    }
  },
  watch: {
    block: {
      handler(newBlock) {
        if (newBlock?.data?.media && newBlock.data.media[this.$i18n.locale]) {
          this.mediaFile = newBlock.data.media[this.$i18n.locale].preview_url
        }
      },
      immediate: true
    }
  }
}
</script> 